import React from 'react'
import { PaginationContent } from './components/PaginationContent'
import { useLocation } from 'react-router-dom'
import { Paging } from './usePagination'

export interface PaginationProps {
    setPage?: (page: number) => void
    itemCount: number
    paging: Paging
    maxPages?: number
    params?: string
    hideNavText?: boolean
    hideItemBorder?: boolean
    hideJumpButton?: boolean
    onEvent: (event: any) => void
}

/** A pagination component for The Nightly. */
export const Pagination = ({
    itemCount,
    paging,
    setPage,
    maxPages,
    params,
    onEvent,
    hideNavText,
    hideItemBorder = true,
    hideJumpButton,
}: PaginationProps) => {
    const { pathname } = useLocation()

    return (
        <PaginationContent
            currentPage={paging.page}
            pageSize={paging.pageSize}
            maxPages={maxPages}
            publicationCount={itemCount}
            setPage={setPage}
            path={pathname}
            params={params}
            onEvent={onEvent}
            hideNavText={hideNavText}
            hideItemBorder={hideItemBorder}
            hideJumpButton={hideJumpButton}
        />
    )
}
